import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, EnumDecoder, field, IntegerDecoder, StringDecoder } from '@common/encoding';
import { v4 as uuidv4 } from 'uuid';
import { PaymentProvider } from '../PaymentProvider.js';
import { SettlementStatus } from './SettlementStatus.js';
/**
 * One payout of a payment provider, stored locally. Always owned by an organization; payouts of the
 * platform's own accounts belong to the platform membership organization and have
 * `stripeAccountId === null`.
 */
export class Settlement extends AutoEncoder {
    id;
    provider;
    /**
     * The provider's id for this payout (Stripe payout id / Mollie settlement id).
     */
    externalId;
    stripeAccountId = null;
    organizationId;
    /**
     * Statement descriptor / Mollie reference, to match against a bank statement.
     */
    reference = '';
    amount = 0;
    currency = 'EUR';
    status = SettlementStatus.Paid;
    settledAt;
    /**
     * Set only after a complete, error-free sync. NULL means "needs attention or retry".
     */
    syncedAt = null;
    syncFailureCount = 0;
    /**
     * amount minus the sum of all stored payment lines, charges and pending fees, cached after
     * every sync. Expected to be 0.
     */
    unexplainedAmount = 0;
    /**
     * Application fees received in this platform payout that are not invoiced yet, so no payment
     * line explains them yet.
     */
    pendingFees = 0;
    transactionCount = 0;
    createdAt = new Date();
    updatedAt = new Date();
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Settlement.prototype, "id", void 0);
__decorate([
    field({ decoder: new EnumDecoder(PaymentProvider) })
], Settlement.prototype, "provider", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Settlement.prototype, "externalId", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], Settlement.prototype, "stripeAccountId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Settlement.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Settlement.prototype, "reference", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], Settlement.prototype, "amount", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Settlement.prototype, "currency", void 0);
__decorate([
    field({ decoder: new EnumDecoder(SettlementStatus) })
], Settlement.prototype, "status", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Settlement.prototype, "settledAt", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], Settlement.prototype, "syncedAt", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], Settlement.prototype, "syncFailureCount", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], Settlement.prototype, "unexplainedAmount", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 409 })
], Settlement.prototype, "pendingFees", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], Settlement.prototype, "transactionCount", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Settlement.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: DateDecoder })
], Settlement.prototype, "updatedAt", void 0);
//# sourceMappingURL=Settlement.js.map